import type { VendorMeta } from '../types'

export const VENDORS: VendorMeta[] = [
  {
    id: 'gdc',
    name: 'GDC (Global Data Consortium)',
    overlaps: [
      { vendor: 'socure', warning: 'GDC and Socure HAVE overlapping data sources. For Two_plus customers, do NOT pair them together without confirming they are not using the same underlying source.' },
    ],
    consent_required: false,
    batch_reliable: true,
    notes: 'Often used internationally. Allow ~10 business days for direct batch turnaround. Contact: Ahan (primary), Lindsay Hatton (introductions).',
  },
  {
    id: 'datazoo',
    name: 'Data Zoo',
    overlaps: [
      { vendor: 'gdc', warning: 'Datazoo and GDC do NOT have crossover of data sources, but they may directly connect to the same underlying source — proceed with care in cascade.' },
    ],
    consent_required: false,
    batch_reliable: true,
    notes: 'Commonly used. Reachable for direct file drops. Contact: Ahan (primary).',
  },
  {
    id: 'socure',
    name: 'Socure',
    overlaps: [
      { vendor: 'gdc', warning: 'Socure and GDC DO HAVE overlapping data sources. For Two_plus customers, do NOT pair them together without confirming they are not using the same underlying source.' },
    ],
    consent_required: false,
    batch_reliable: false,
    notes: 'Available but UNRELIABLE for batch turnaround. Requires Alvin Atthariq for root config changes (separate Jira ticket). Country-specific address matching must be set in root config.',
  },
  {
    id: 'equifax',
    name: 'Equifax',
    overlaps: [],
    consent_required: true,
    batch_reliable: true,
    notes: 'Consent-based source. Customer must have their own credentials and confirmed legal consent before POC can proceed.',
  },
  {
    id: 'experian',
    name: 'Experian',
    overlaps: [],
    consent_required: true,
    batch_reliable: true,
    notes: 'Consent-based source. Customer must have their own credentials and confirmed legal consent before POC can proceed.',
  },
  {
    id: 'dvs',
    name: 'DVS (Document Verification Service)',
    overlaps: [],
    consent_required: true,
    batch_reliable: true,
    notes: 'Australian Government ID verification. Consent required. Verifies document details against government databases (not physical documents).',
  },
  {
    id: 'centrix',
    name: 'Centrix',
    overlaps: [],
    consent_required: false,
    batch_reliable: true,
    notes: 'New Zealand credit bureau. Commonly used for NZ KYC.',
  },
  {
    id: 'superchoice',
    name: 'Superchoice',
    overlaps: [],
    consent_required: false,
    batch_reliable: true,
    notes: 'Australian superannuation verification.',
  },
  {
    id: 'prove',
    name: 'Prove',
    overlaps: [],
    consent_required: false,
    batch_reliable: true,
    notes: 'Phone-centric identity verification. Available in US and Brazil only.',
    country_codes: ['US', 'BR'],
  },
  {
    id: 'asia_verify',
    name: 'Asia Verify',
    overlaps: [],
    consent_required: false,
    batch_reliable: true,
    notes: 'Identity verification for China. Available in China only.',
    country_codes: ['CN'],
  },
]

export function getVendor(id: string): VendorMeta | undefined {
  return VENDORS.find(v => v.id === id)
}

export function getOverlapWarnings(vendorIds: string[]): { vendor1: string; vendor2: string; warning: string }[] {
  const warnings: { vendor1: string; vendor2: string; warning: string }[] = []
  for (let i = 0; i < vendorIds.length; i++) {
    const v = VENDORS.find(v => v.id === vendorIds[i])
    if (!v) continue
    for (const overlap of v.overlaps) {
      if (vendorIds.includes(overlap.vendor) && !warnings.some(w => (w.vendor1 === overlap.vendor && w.vendor2 === v.id))) {
        warnings.push({ vendor1: v.id, vendor2: overlap.vendor, warning: overlap.warning })
      }
    }
  }
  return warnings
}
